import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
  getRateLimitMessage,
  parseRetryAfter,
  resolveApiErrorMessage,
} from '@app/core/utils/api-error.util';
import { ToastService } from '@app/shared/services/toast-service.service';

const UNKNOWN_ERROR_MESSAGE = 'Unknown error occurred, kindly retry.';

export const errorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const dialog = inject(MatDialog);
  const snackbar = inject(ToastService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        if (!request.url.includes('/accounts/logout')) {
          snackbar.error('Access Denied');
          dialog.closeAll();
          router.navigate(['/forbidden']);
        }
        return throwError(() => error);
      } else if (error.status === 401) {
        return throwError(() => error);
      } else {
        if (
          request.headers.has('disable_toast') &&
          request.headers.get('disable_toast') === 'true'
        ) {
          return throwError(() => error);
        }

        snackbar.error(getErrorMessage(error));
        return throwError(() => error);
      }
    }),
  );
};

function getErrorMessage(error: HttpErrorResponse): string {
  if (error.status === 429) {
    return getRateLimitMessage(parseRetryAfter(error.headers.get('Retry-After')));
  }

  return resolveApiErrorMessage(error.error) ?? UNKNOWN_ERROR_MESSAGE;
}
